/**
 * Asynchronously loads the component for HomePage
 */

import React from "react";
import loadable from "utils/loadable";
import ClipLoader from "react-spinners/ClipLoader";


export default loadable(() => import("./index"), {
  fallback: (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <ClipLoader size={100} color={"#123abc"} loading={true} />
    </div>
  ),
});
